import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Small "Suggested: N" pill driven by historical sell-through.
 * Tapping it applies the suggested quantity. Low-confidence suggestions
 * (limited history) get a muted style + explanatory tooltip.
 */
export const SuggestedQtyChip = ({ suggestion, onApply, className = '' }) => {
  if (!suggestion || suggestion.suggested_qty == null) return null;
  const low = suggestion.confidence === 'low';
  const tip = low
    ? `Based on limited history (${suggestion.sample_size} recent ${suggestion.sample_size === 1 ? 'delivery' : 'deliveries'})`
    : `Based on your last ${suggestion.sample_size} ${suggestion.basis === 'weekday' ? 'same-weekday' : 'recent'} deliveries`;

  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onApply?.(suggestion.suggested_qty); }}
      title={tip}
      data-testid="suggested-qty-chip"
      data-confidence={suggestion.confidence}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium transition-colors ${
        low
          ? 'border-slate-200 bg-slate-50 text-slate-500 hover:bg-slate-100'
          : 'border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100'
      } ${className}`}
    >
      <Sparkles className="h-3 w-3" />
      Suggested: {suggestion.suggested_qty}
    </button>
  );
};

export default SuggestedQtyChip;
